<div class="container frontdesk-container">
    <div class="right-container">
        <app-rightpane></app-rightpane>
    </div>
    <div class="left-container">
        <app-leftpane></app-leftpane>
    </div>
</div>